import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=7cd87255&scoped=true&"
import script from "./BurgerMenu.vue?vue&type=script&lang=js&"
export * from "./BurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&id=7cd87255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd87255",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd87255')) {
      api.createRecord('7cd87255', component.options)
    } else {
      api.reload('7cd87255', component.options)
    }
    module.hot.accept("./BurgerMenu.vue?vue&type=template&id=7cd87255&scoped=true&", function () {
      api.rerender('7cd87255', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/BurgerMenu.vue"
export default component.exports